import { TooltipProvider } from "@reactive-resume/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router-dom";

import { AnalyticsTracker } from "../components/AnalyticsTracker";
import { CookieSettingsDialog } from "../components/cookie-settings/CookieSettings";
import { Ga4ContextSync } from "../components/Ga4ContextSync";
import { MixpanelInitializer } from "../components/MixpanelInitializer";
import { PaymentConfirmationHandler } from "../components/PaymentConfirmationHandler";
import { PlanDialog } from "../components/plan-dialog/PlanDialog";
import { helmetContext } from "../constants/helmet";
import { queryClient } from "../libs/query-client";
import { ClerkAppProvider } from "./clerk";
import { DialogProvider } from "./dialog";
import { LocaleProvider } from "./locale";
import { ThemeProvider } from "./theme";
import { Toaster } from "./toaster";

export const Providers = () => (
  <LocaleProvider>
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}>
        <ClerkAppProvider>
          <ThemeProvider>
            <TooltipProvider>
              <DialogProvider>
                <MixpanelInitializer />
                <AnalyticsTracker />
                <Ga4ContextSync />
                <PaymentConfirmationHandler />
                <Outlet />

                {/* The First Round plan dialog: one instance, opened from anywhere (signed in). */}
                <PlanDialog />
                {/* Cookie settings (Privacy Policy 7.5), opened from footers and the account menu. */}
                <CookieSettingsDialog />
                <Toaster />
              </DialogProvider>
            </TooltipProvider>
          </ThemeProvider>
        </ClerkAppProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </LocaleProvider>
);
